/* istanbul ignore file */
import React from 'react';
import { Provider } from 'react-redux';
import { createRoot, Root } from 'react-dom/client';
import { store } from './Managers/Redux/Store';
import './ConfigLoader/I18n';
import { App } from './App';

const rootElement: HTMLElement | null = document.getElementById('gf-app-root');
if (!rootElement) throw new Error('Failed to find the root element');

const root: Root = createRoot(rootElement);

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
